/* ============
 * All Cities
 * ============
 *
 * All cities from a country.
 */

import Vue from 'vue';
import store from './../../store';
import productTagTransformer from './../../transformers/productTag';

const success = ({ data }, resolve) => {
  const tags = productTagTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllProductTags', tags);
  resolve(tags);
};

const failed = () => {
};

// Display cities related to a country.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('product_tags')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productTag/all.js